const canUseStorage = () => typeof window !== "undefined" && Boolean(window.localStorage);

export const loadSavedPageState = (storageKey, defaultState) => {
  if (!canUseStorage()) {
    return defaultState;
  }
  try {
    const rawValue = window.localStorage.getItem(storageKey);
    if (!rawValue) {
      return defaultState;
    }
    const parsedValue = JSON.parse(rawValue);
    if (!parsedValue || typeof parsedValue !== "object") {
      return defaultState;
    }
    return {
      ...defaultState,
      ...parsedValue,
      filters: {
        ...(defaultState.filters || {}),
        ...(parsedValue.filters || {}),
      },
    };
  } catch (_error) {
    return defaultState;
  }
};

export const savePageState = (storageKey, value) => {
  if (!canUseStorage()) {
    return;
  }
  window.localStorage.setItem(storageKey, JSON.stringify(value));
};

export const clearSavedPageState = (storageKey) => {
  if (!canUseStorage()) {
    return;
  }
  window.localStorage.removeItem(storageKey);
};